import React from 'react'

const messageSuccess = () =>{

    return(
    <div className='sent'>
        <h1>Thank you, Ill get back to you asap!</h1>
    </div>
    )
}

export default messageSuccess